export const CLASS_MAGIC_LINK= 'magic-link';
